import { render } from "./ElegibilidadForm.vue?vue&type=template&id=36458686"
import script from "./ElegibilidadForm.vue?vue&type=script&lang=js"
export * from "./ElegibilidadForm.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__